import React from "react";
import Testimonials from "./Testimonials";

const testimonials = [
  {
    quote:
      "We use Opendoor as an additional tool in our traditional listing appointment. We always want to present clients with an Opendoor offer—that adds to our arsenal of ways to sell a home.",
    name: "Darby Shields",
    broker: "Revolution Realty"
  },
  {
    quote:
      "The offer was good and the closing was on time. The process was exactly as promised in every respect. I was a licensed Realtor for 17 years and would still recommend any seller to at least get a quote from Opendoor.",
    name: "George Lizer"
  },
  {
    quote:
      "I create listing appointments because I have Opendoor as a tool in my belt. I say to clients, I can get you a cash offer or list traditionally—whatever works better for you. If you need to sell more quickly, this is the way to go.",
    name: "Shannon Fitzpatrick",
    broker: "Movoto Real Estate"
  },
  {
    quote:
      "Opendoor is a platform and solution that the industry needs. Part of the excitement is being able to say to sellers, here are several models for you to choose from, let’s talk about what’s best for you. Offering this service and education to clients has been rewarding.",
    name: "Beau Bourquin",
    broker: "Keller Williams Realty"
  }
];

function OpendoorTestimonials() {
  return (
    <Testimonials
      title="Agents &#x1F499; Opendoor"
      testimonials={testimonials}
    />
  );
}

export default OpendoorTestimonials;
